<template>
  <AppSection
    id="question-form-page"
    :title="$t($getConst.pages.sms_configuration.sms_template_page_title)"
    type="section"
    select-language
    :is-section-loading="is_loading"
  >

    <b-row class="justify-content-center py-5">

      <template v-for="option in options">
        <b-col v-if="!is_loading && option.is_shown" xl="3" lg="4" md="4" sm="6" class="pb-4">
          <AppPageOptionBox
            @onClick="onSelectOption(option)" :text="option.text" :icon="option.icon"/>
        </b-col>
      </template>

    </b-row>

  </AppSection>
</template>

<script>

  import AppSection from "../../../../../../components/common/sections/AppSection";
  import AppPageOptionBox from "../../../../../../components/common/utils/AppPageOptionBox";
  import {getOneScope} from "../../../../../../api/scopes.api";
  export default {
    name: "index",
    components: {AppSection, AppPageOptionBox},
    props: {
      scope_id: null
    },
    data() {
      return {
        is_loading: false,
        scope: null
      }
    },
    computed: {
      options() {
        if (this.scope) {
          return [
            {
              destination: "TIMESHEETS",
              text: this.$t(this.$getConst.pages.sms_configuration.timesheets_sms_templates),
              icon:this.$getConst.svgIcons.chat_dots,
              is_shown: true
            },
            {
              destination: "FREELANCER",
              text: this.$t(this.$getConst.pages.sms_configuration.freelancer_sms_templates),
              icon:this.$getConst.svgIcons.freelancer,
              is_shown: this.scope.is_freelancers_enabled
            },
          ];
        }
      }
    },
    methods: {
      getScope() {
        this.is_loading = true;
        getOneScope(this.scope_id).then(
          response => {
            this.scope = response.data;
            this.is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.is_loading = false;
          }
        )
      },
      onSelectOption(option) {
        switch (option.destination) {
          case "TIMESHEETS":
            this.$router.push({name: this.$getConst.routesNames.administration.smsTemplates, params: {type: 'timesheets'}});
            break;
          case "FREELANCER":
            this.$router.push({name: this.$getConst.routesNames.administration.smsTemplates, params: {type: 'freelancer'}});
            break;
          default:
            break;
        }
      }
    },
    created() {
      this.getScope();
    }
  }
</script>

<style scoped>

</style>
